import customFetch from '@/api/fetch';

export interface CreateFCMTokenInput {
  token: string;
  userId?: string;
  deviceId?: string;
  platform?: string;
}

export interface FCMTokenResponse {
  id: string;
  token: string;
  userId?: string;
  deviceId?: string;
  platform?: string;
}

export const saveFCMToken = async (tokenData: CreateFCMTokenInput): Promise<FCMTokenResponse> => {
  const platform = detectPlatform();
  const deviceId = tokenData.deviceId || (typeof window !== 'undefined' ? generateDeviceId() : 'server-side');

  const payload: CreateFCMTokenInput = {
    ...tokenData,
    platform: tokenData.platform || platform,
    deviceId,
  };

  const result = await customFetch('/fcm-tokens', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  console.log('FCM token saved successfully');
  return result;
};

export const deleteFCMToken = async (tokenId: string): Promise<void> => {
  await customFetch(`/fcm-tokens/${tokenId}`, {
    method: 'DELETE',
  });
  console.log('FCM token deleted successfully');
};

function detectPlatform(): string {
  if (typeof window === 'undefined') {
    return 'web';
  }

  const userAgent = navigator.userAgent.toLowerCase();

  // Detectar se é um app mobile (iOS ou Android)
  if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod')) {
    // Se estiver rodando em um WebView do iOS, ainda é 'web'
    // Apps nativos iOS usariam o SDK nativo, não este código web
    return 'web';
  }

  if (userAgent.includes('android')) {
    // Se estiver rodando em um WebView do Android, ainda é 'web'
    // Apps nativos Android usariam o SDK nativo, não este código web
    return 'web';
  }

  // Para PWAs ou aplicações web
  return 'web';
}

function generateDeviceId(): string {
  if (typeof window === 'undefined') {
    return `server_${Date.now()}`;
  }

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx?.fillText('Device fingerprint', 10, 10);

  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    screen.width + 'x' + screen.height,
    new Date().getTimezoneOffset(),
    canvas.toDataURL(),
  ].join('|');

  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  return `web_${Math.abs(hash).toString(36)}`;
}
